export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.cfb05c89.woff2";